<template>
  <div style="margin:0;padding:0;" id="report_container" class="report-container">

    <!-- 第一页：封面页 -->
    <div class="page cover-page print-cover-page"
      style="width: 100%; height: 100vh; display: flex; flex-direction: column; position: relative; page-break-after: always; padding: 0 5vw;">
      <!-- Logo和标题区域 -->
      <div class="cover-top-section"
        style="display: flex; align-items: center; justify-content: center; position: absolute; width: 100%; top: calc(100vh / 6); left: 50%; transform: translateX(-50%);">
        <!-- Logo和第三方检测机构 -->
        <div class="cover-logo-section"
          style="display: flex; flex-direction: column; align-items: center; position: absolute; right: calc(50% + 2.2cm);">
          <el-image class="cover-logo" fit="contain" :src="company.logo_url"
            style="width: calc(100vw / 4.5); height: calc(100vw / 4.5);">
          </el-image>
          <div class="cover-org-text"
            style="font-size: 40px !important; color: #333; text-align: center; font-weight: bold; margin-top: 0.5cm !important; padding-top: 0.5cm !important;">
            第三方检测机构</div>
        </div>

        <!-- 分隔线 - 水平居中 -->
        <div class="cover-divider"
          style="width: 4px; height: 26vw; background-color: #666; position: absolute; left: 50%; transform: translateX(-50%);">
        </div>

        <!-- 标题文字 -->
        <div class="cover-title-section" style="text-align: left; position: absolute; left: calc(50% + 2.2cm);">
          <div class="cover-title-1"
            style="font-size: 100px !important; font-weight: bold !important; color: #333 !important; margin-bottom: 2vw !important; line-height: 1.2 !important;">
            车辆检测</div>
          <div class="cover-title-2"
            style="font-size: 100px !important; font-weight: bold !important; color: #333 !important; line-height: 1.2 !important;">
            评估报告</div>
        </div>
      </div>

      <!-- 二维码 -->
      <div class="cover-qr-section"
        style="position: absolute; width: 100%; bottom: calc(100vh / 5 + 60px); left: 0; display: flex; justify-content: center; align-items: center;">
        <el-image class="cover-qr" fit="contain"
          :src="company.qrcode_url || (urls.static.qrcode + '?order_id=' + order.identifier)"
          style="width: calc(100vw / 3); height: calc(100vw / 3); border: 1px solid #ddd;">
        </el-image>
      </div>

      <!-- 公司名称 -->
      <div class="cover-company-name"
        style="position: absolute; bottom: 2cm; left: 50%; transform: translateX(-50%); white-space: nowrap;">
        <div style="font-size: 2.2vw; color: #333; font-weight: bold;">福州车质宝检测服务有限公司</div>
      </div>
    </div>

    <!-- 第二页：车辆检测报告详情页 -->
    <div class="page second-page" style="width: 100%; min-height: 100vh; page-break-after: always; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-bar"
        style="background: #0072ff; height: 160px; display: flex; align-items: center; justify-content: space-between; padding: 0 30px; color: white; margin: 0; width: 100%; box-sizing: border-box;">
        <div class="logo-title-part" style="display: flex; align-items: center;">
          <div
            style="width: 90px; height: 90px; background: white; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin-right: 20px;">
            <el-image class="auto-detect-report-logo" fit="contain" :src="company.logo_url"
              style="width: 75px; height: 75px;">
            </el-image>
          </div>
          <div class="auto-detect-report-title-part">
            <h2 class="auto-detect-report"
              style="margin: 0; font-size: 32px; font-weight: bold; color: white; line-height: 1.3;">车辆检测报告</h2>
            <p class="auto-detect-report-eng"
              style="margin: 8px 0 0 0; font-size: 18px; opacity: 0.9; color: white; line-height: 1.2;">THE VEHICLE
              INSPECTION REPORT</p>
          </div>
        </div>
        <div class="report-info-part" style="text-align: right; font-size: 18px; line-height: 1.8; color: white;">
          <div style="color: white; margin-bottom: 4px;">检测时间：{{ order.detected_at | formatDateZH }}</div>
          <div style="color: white;">授权机构：{{ company.full_name }}</div>
        </div>
      </div>

      <!-- 车辆信息区域 -->
      <div class="auto-info-zone" style="display: flex; padding: 30px; gap: 30px; align-items: flex-start;">
        <!-- 车辆图片 -->
        <div class="auto-info-img" style="flex: 0 0 240px;">
          <el-image fit="cover" :src="default_cover_url"
            style="width: 400px; height: 300px; border-radius: 8px; border: 1px solid #e8e8e8;">
          </el-image>
        </div>

        <!-- 车辆基本信息 -->
        <div class="auto-info-base" style="flex: 1; padding-left: 20px;">
          <div style="padding: 20px; border-radius: 8px; margin-bottom: 20px;">
            <h3 class="auto-info-base-title"
              style="margin: 0 0 15px 0; font-size: 18px; font-weight: bold; color: #333;">{{ company.full_name }}</h3>
            <div class="auto-info-base-sub"
              style="display: grid; grid-template-columns: 120px 1fr; gap: 8px; font-size: 14px; line-height: 1.6;">
              <div style="color: #666;">VIN</div>
              <div style="font-weight: 500;">{{ auto.vin_no }}</div>
              <div style="color: #666;">车牌号</div>
              <div style="font-weight: 500;">{{ auto.license_plate }}</div>
              <div style="color: #666;">打印时间</div>
              <div style="font-weight: 500;">{{ getDate() }}</div>
            </div>
          </div>
        </div>

        <!-- 二维码区域 -->
        <div style="flex: 0 0 120px; text-align: center;">
          <el-image fit="contain" :src="urls.static.qrcode + '?order_id=' + order.identifier"
            style="width: 100px; height: 100px; border: 1px solid #ddd; border-radius: 4px;">
          </el-image>
          <p class="auto-info-base-qrcode-text"
            style="font-size: 12px; margin: 8px 0 0 0; color: #666; line-height: 1.3;">扫描查看电子报告</p>
        </div>
      </div>

      <!-- 检测概要 -->
      <div class="auto-info-summary" style="padding: 0 30px 20px;">
        <div style="display: flex; align-items: flex-start; margin-bottom: 15px; height: 30px; line-height: 30px;">
          <div style="display:block;width: 8px; height: 24px; background: #0072ff; margin-top: 3px; flex-shrink: 0;">
          </div>
          <div style="display:block;width: 8px; height: 24px;margin-top: 3px; flex-shrink: 0;"></div>
          <h3 class="auto-info-summary-title"
            style="display:block;font-size: 16px; font-weight: bold; color: #333; line-height: 24px; height: 24px; display: flex; align-items: center;margin-top:3px;">
            检测概要</h3>
        </div>
        <div class="auto-info-summary-table" style="border: 1px solid #e8e8e8; border-radius: 4px;margin-top:20px;">
          <a-table class="auto-info-summary-table-columns" :columns="detect_result_columns"
            :data-source="detect_result_table_data" :pagination="false" :showHeader="true" bordered size="small"
            style="margin: 0;text-align: left;">
            <template v-for="col in ['detect_item', 'result', 'detect_item_1', 'result_1']" :slot="col"
              slot-scope="text">
              <div class="auto-info-summary-table-column" :key="col" style="padding: 8px; text-align: left;">
                <template v-if="col == 'result' || col == 'result_1'">
                  <el-image fit="contain" v-if="text != undefined && text != ''"
                    :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                    style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                  </el-image>
                  <span class="auto-info-summary-result"
                    style="vertical-align: middle; font-size: 15px;text-align: left;">{{ text }}</span>
                </template>
                <template v-else>
                  <span class="auto-info-summary-result" style="font-size: 15px; color: #333;text-align: left;">{{ text
                    }}</span>
                </template>
              </div>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 检测机构信息 -->
      <div class="auto-info-inspector" style="padding: 0 30px 30px;">
        <div style="display: flex; align-items: flex-start; margin-bottom: 15px; height: 30px; line-height: 30px;">
          <div style="width: 8px; height: 24px; background: #0072ff; margin-top: 2px; flex-shrink: 0;"></div>
          <div style="width: 8px; height: 24px; margin-top: 2px; flex-shrink: 0;"></div>
          <h3 class="auto-info-inspector-title"
            style="margin: 0; font-size: 16px; font-weight: bold; color: #333; line-height: 24px; height: 24px; display: flex; align-items: center;margin-top:3px;">
            检测机构</h3>
        </div>

        <div class="auto-info-inspector-info"
          style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; font-size: 14px; line-height: 1.8;margin-top: 20px;">
          <div>
            <div><span style="color: #666; display: inline-block; width: 70px;">检测师：</span><span
                style="font-weight: 500;">{{
                inspector.name }}</span></div>
            <div><span style="color: #666; display: inline-block; width: 70px;">报告编号：</span><span
                style="font-weight: 500;">C{{ order.id }}</span></div>
            <div><span style="color: #666; display: inline-block; width: 70px;">客服热线：</span><span
                style="font-weight: 500;">{{
                  company.office_line_number }}</span></div>
          </div>
          <div>
            <div><span style="color: #666; display: inline-block; width: 70px;">检测时间：</span><span
                style="font-weight: 500;">{{
                  order.detected_at | formatDate }}</span></div>
            <div><span style="color: #666; display: inline-block; width: 70px;">机构名称：</span><span
                style="font-weight: 500;">{{
                  company.institution_name }}</span></div>
            <div><span style="color: #666; display: inline-block; width: 70px;">授权机构：</span><span
                style="font-weight: 500;">{{
                  company.full_name }}</span></div>
          </div>
        </div>
      </div>

      <!-- 检测结果说明 -->
      <div class="auto-info-result"
        style="padding: 20px 30px; border-top: 1px solid #e8e8e8; margin-top: 20px; position: relative;">
        <p style="font-size: 14px; line-height: 1.6; margin: 0; color: #333; padding-right: 120px;">
          <strong>检测结果及保养建议：</strong>{{ order.maintenance_recommendations }}
        </p>

        <!-- 红色印章调整位置：水平居中偏右50px -->
        <div style="position: absolute; top: 50%; left: 50%; transform: translate(calc(-50% + 50px), -50%);">
          <el-image fit="cover" :src="urls.static.company_searl"
            style="width:10vw;height:10vw;margin-top:7vw;text-align:center;">
          </el-image>
        </div>
      </div>

      <!-- 页码 -->
      <div class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        1/{{ total_page }}
      </div>
    </div>

    <!-- 第3页：基本信息页面 -->
    <div class="page"
      style="width:100%;page-break-after: always; padding: 20px 30px; background: white; height: 297mm; box-sizing: border-box; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;display:block;">
        <span class="blue-title-nav-bar"
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; font-size: 16px; box-sizing: border-box;">
          基本信息
        </span>
      </div>

      <!-- 车主信息 -->
      <div style="margin-bottom: 15px;">
        <div class="auto-base-info-content" style="width: 100%; height: 20px; margin-bottom: 8px;margin-top:40px;">
          <div class="blue_flag" style="float: left; width: 8px; height: 20px; background: #155cf0;"></div>
          <span class="blue_right_words"
            style="float: left; font-size: 16px; line-height: 20px; display: block; margin-left: 8px; font-weight: bold;">
            车主信息
          </span>
          <div style="clear: both;"></div>
        </div>
        <a-table class="auto_customer_table auto-base-info-content" :columns="customer_columns"
          :data-source="customer_table_data" :showHeader="false" :pagination="false" :size="'small'" bordered
          style="font-size: 16px;margin-top:40px;">
          <template v-for="col in ['name_item', 'name', 'mobile_item', 'mobile', 'id_item', 'id']" :slot="col"
            slot-scope="text">
            <div class="auto-customer-info-table-content" :key="col"
              style="padding: 6px; font-size: 16px;text-align: left;"
              :style="col.includes('_item') ? 'background: white; font-weight: bold;' : ''">
              {{ text }}
            </div>
          </template>
        </a-table>
      </div>

      <!-- 基本信息 -->
      <div style="margin-bottom: 15px;margin-top: 40px;">
        <div class="auto-base-info-content" style="width: 100%; height: 20px; margin-bottom: 8px;">
          <div class="blue_flag" style="float: left; width: 8px; height: 20px; background: #155cf0;"></div>
          <span class="blue_right_words"
            style="float: left; font-size: 16px; line-height: 20px; display: block; margin-left: 8px; font-weight: bold;">
            基本信息
          </span>
          <div style="clear: both;"></div>
        </div>
        <a-table class="auto-base-info-content" :columns="base_info_columns" :data-source="base_info_table_data"
          :showHeader="false" :pagination="false" :size="'small'" bordered style="font-size: 16px;margin-top:40px;">
          <template v-for="col in ['info_item', 'info', 'info_item_1', 'info_1', 'info_item_2', 'info_2']" :slot="col"
            slot-scope="text">
            <div class="auto-base-info-table-content" :key="col" style="padding: 6px; font-size: 16px;"
              :style="col.includes('_item') ? 'background: white; font-weight: bold;' : ''">
              {{ text }}
            </div>
          </template>
        </a-table>
      </div>

      <!-- 加强件检测 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;margin-top: 100px;">
        <span class="blue-title-nav-bar"
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; font-size: 16px;">
          加强件检测
        </span>
      </div>
      <div style="font-size: 12px;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[reinforcement_group_object.group_object_id]" :pagination="false"
          :size="'small'" bordered style="font-size: 12px;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col">
              <template>
                <template v-if="col == 'result' || col == 'result_1'">
                  <el-image fit="contain" v-if="text != undefined && text != ''"
                    :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                    style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                  </el-image>
                  <span class="auto-customer-info-table-content"
                    style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
                </template>
                <template v-else>
                  <span class="auto-customer-info-table-content"
                    style="font-size: 14px; color: #333;text-align: left;">{{ text }}</span>
                </template>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论 -->
      <div class="sub-content-result" style="margin-top: 10px; font-size: 14px; font-weight: bold;">
        结论: {{ reinforcement_group_object.test_result || '检测正常' }}
      </div>
      <div class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        2/{{ total_page }}
      </div>
    </div>
    <!-- 第3页：灯光检测 -->
    <div v-if="order.menu_mode == 'COMPREHENSIVE' && order.detected" class="page"
      style="width:100%;page-break-after: always; padding: 20px 30px; background: white; height: 297mm; box-sizing: border-box; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;">
        <span class="blue-title-nav-bar"
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; box-sizing: border-box; ">
          灯光检测
        </span>
      </div>

      <!-- 检测结果表格 -->
      <div style="margin-top:30px;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[illumination_inspection_group_object.group_object_id]"
          :pagination="false" bordered size="small" style="width:100%;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col">
              <template v-if="col == 'result' || col == 'result_1'">
                <el-image fit="contain" v-if="text != undefined && text != ''"
                  :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                  style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                </el-image>
                <span class="auto-customer-info-table-content"
                  style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
              </template>
              <template v-else>
                <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                  text }}</span>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论 -->
      <div class="sub-content-result" style="margin-top:30px;">
        <p style="width:100%;word-break:break-all;word-wrap:break-word;font-size:18px;font-weight:bold;margin:0;">
          结论: {{ illumination_inspection_group_object.test_result || '检测正常' }}
        </p>
      </div>
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;margin-top: 100px;">
        <span
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; box-sizing: border-box; ">
          车窗玻璃
        </span>
      </div>

      <!-- 检测结果表格 -->
      <div style="margin-top:30px;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[car_window_glass_group_object.group_object_id]"
          :pagination="false" bordered size="small" style="width:100%;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col">
              <template v-if="col == 'result' || col == 'result_1'">
                <el-image fit="contain" v-if="text != undefined && text != ''"
                  :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                  style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                </el-image>
                <span class="auto-customer-info-table-content"
                  style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
              </template>
              <template v-else>
                <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                  text }}</span>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论 -->
      <div class="sub-content-result" style="margin-top:30px;">
        <p style="width:100%;word-break:break-all;word-wrap:break-word;font-size:18px;font-weight:bold;margin:0;">
          结论: {{ car_window_glass_group_object.test_result || '检测正常' }}
        </p>
      </div>

        <!-- 页码 -->
        <div class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        {{ total_page - 7 }}/{{ total_page }}
    </div>

    </div>
    <!-- 第5页：覆盖件及漆面检测 -->
    <div class="page"
      style="width:100%;page-break-after: always; padding: 20px 30px; background: white; height: 297mm; box-sizing: border-box; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;">
        <span class="blue-title-nav-bar lacquered-title-nav-bar"
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; box-sizing: border-box; ">
          覆盖件及漆面检测
        </span>
      </div>

      <!-- 车辆示意图区域 - 强制样式控制 -->
      <div
        style="margin-top:30px !important;text-align:center !important;width:100% !important;height:500px !important;display:flex !important;align-items:center !important;justify-content:center !important;position:relative !important;z-index:10 !important;overflow:hidden !important;">
        <img
          :src="global_define.api_url_domain + '/detect/cover?order_id=' + String(order.identifier) + '&group_id=' + String(lacquered_group_object.group_object_group_id)"
          style="height:500px !important;width:auto !important;max-width:100% !important;object-fit:contain !important;object-position:center !important;display:block !important;margin:0 auto !important;">
      </div>

      <!-- 检测结果表格 -->
      <div style="margin-top:30px;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[lacquered_group_object.group_object_id]" :pagination="false"
          bordered size="small" style="width:100%;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col">
              <template v-if="col == 'result' || col == 'result_1'">
                <el-image fit="contain" v-if="text != undefined && text != ''"
                  :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                  style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                </el-image>
                <span class="auto-customer-info-table-content"
                  style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
              </template>
              <template v-else>
                <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                  text }}</span>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论 -->
      <div class="sub-content-result" style="margin-top:30px;">
        <p style="width:100%;word-break:break-all;word-wrap:break-word;font-size:18px;font-weight:bold;margin:0;">
          结论: {{ lacquered_group_object.test_result || '检测正常' }}
        </p>
      </div>

      <!-- 页码 -->
      <div v-if="order.menu_mode == 'COMPREHENSIVE'" class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        {{ total_page - 6 }}/{{ total_page }}
      </div>
      <div v-if="order.menu_mode == 'BASE'" class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        3/{{ total_page }}
      </div>
    </div>
    <!-- 第6页：结构件检测 -->
    <div class="page"
      style="width:100%;page-break-after: always; padding: 20px 30px; background: white; height: 297mm; box-sizing: border-box; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;display:block;">
        <span class="blue-title-nav-bar"
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center;">
          结构件检测
        </span>
      </div>

      <!-- 车辆结构示意图区域 - 强制样式控制 -->
      <div
        style="margin-top:30px !important;text-align:center !important;width:100% !important;height:500px !important;display:flex !important;align-items:center !important;justify-content:center !important;position:relative !important;z-index:10 !important;overflow:hidden !important;">
        <img
          :src="global_define.api_url_domain + '/detect/cover?order_id=' + String(order.identifier) + '&group_id=' + String(structure_group_object.group_object_group_id)"
          style="height:500px !important;width:auto !important;max-width:100% !important;object-fit:contain !important;object-position:center !important;display:block !important;margin:0 auto !important;">
      </div>

      <!-- 检测结果表格 -->
      <div style="margin-top:30px;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[structure_group_object.group_object_id]" :pagination="false"
          bordered size="small" style="width:100%;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col">
              <template>
                <template v-if="col == 'result' || col == 'result_1'">
                  <el-image fit="contain" v-if="text != undefined && text != ''"
                    :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                    style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                  </el-image>
                  <span class="auto-customer-info-table-content"
                    style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
                </template>
                <template v-else>
                  <span class="auto-customer-info-table-content"
                    style="font-size: 14px; color: #333;text-align: left;">{{ text }}</span>
                </template>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论 -->
      <div class="sub-content-result" style="margin-top:30px;">
        <p style="width:100%;word-break:break-all;word-wrap:break-word;font-size:18px;font-weight:bold;margin:0;">
          结论: {{ structure_group_object.test_result || '检测正常' }}
        </p>
      </div>

      <!-- 页码 -->
      <div v-if="order.menu_mode == 'COMPREHENSIVE'" class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        {{ total_page - 5 }}/{{ total_page }}
      </div>
      <div v-if="order.menu_mode == 'BASE'" class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        4/{{ total_page }}
      </div>
    </div>
    <!-- 第6页：泡水检测 -->
    <div class="page"
      style="width:100%;page-break-after:always;padding:20px;box-sizing:border-box; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;display:block;">
        <span class="blue-title-nav-bar"
          style="background:#155cf0;width:200px;height:35px;line-height:35px;color:white;font-weight:bold;display:block;box-sizing:border-box;text-align: center;">
          泡水检测
        </span>
      </div>

      <!-- 车辆泡水检测示意图 - 强制样式控制 -->
      <div
        style="margin:30px 0 !important;text-align:center !important;width:100% !important;height:250px !important;display:flex !important;align-items:center !important;justify-content:center !important;position:relative !important;z-index:10 !important;overflow:hidden !important;">
        <img :src="soaking_investigation_group_object.cover_url"
          style="height:250px !important;width:auto !important;max-width:100% !important;object-fit:contain !important;object-position:center !important;display:block !important;margin:0 auto !important;">
      </div>

      <!-- 四列检测结果表格 -->
      <div style="margin:20px 0;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[soaking_investigation_group_object.group_object_id]"
          :pagination="false" bordered size="small" style="font-size:12px;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col" style="padding:8px;text-align:center;">
              <template v-if="col == 'result' || col == 'result_1'">
                <el-image fit="contain" v-if="text != undefined && text != ''"
                  :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                  style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                </el-image>
                <span class="auto-customer-info-table-content"
                  style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
              </template>
              <template v-else>
                <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                  text }}</span>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论部分 -->
      <div class="sub-content-result" style="margin-top:30px;">
        <p style="font-size:16px;font-weight:bold;margin:0;">
          结论: {{ soaking_investigation_group_object.test_result || '检测正常' }}
        </p>
      </div>

      <!-- 页码 -->
      <div v-if="order.menu_mode == 'COMPREHENSIVE'" class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        {{ total_page - 4 }}/{{ total_page }}
      </div>
      <div v-if="order.menu_mode == 'BASE'" class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        5/{{ total_page }}
      </div>
    </div>
    <!-- 第6页：火烧检测 -->
    <div v-if="order.menu_mode == 'COMPREHENSIVE'" class="page"
      style="width:100%;page-break-after: always; padding: 20px 30px; background: white; height: 297mm; box-sizing: border-box; position: relative;">
      <!-- 蓝色标题栏 -->
        <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;">
            <span class="blue-title-nav-bar"
            style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; box-sizing: border-box; ">
            火烧检测
            </span>
        </div>

        <!-- 车辆示意图区域 - 强制样式控制 -->
        <div
            style="margin-top:30px !important;text-align:center !important;width:100% !important;height:500px !important;display:flex !important;align-items:center !important;justify-content:center !important;position:relative !important;z-index:10 !important;overflow:hidden !important;">
            <img :src="misfire_detection_group_object.cover_url"
            style="height:250px !important;width:auto !important;max-width:100% !important;object-fit:contain !important;object-position:center !important;display:block !important;margin:0 auto !important;">
        </div>

        <!-- 检测结果表格 -->
        <div style="margin-top:30px;">
            <a-table class="sub-content-table" :columns="detect_result_columns"
            :data-source="detect_group_object_table_data[misfire_detection_group_object.group_object_id]"
            :pagination="false" bordered size="small" style="width:100%;">
            <template
                v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
                :slot="col" slot-scope="text">
                <div :key="col">
                <template v-if="col == 'result' || col == 'result_1'">
                    <el-image fit="contain" v-if="text != undefined && text != ''"
                    :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                    style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                    </el-image>
                    <span class="auto-customer-info-table-content"
                    style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
                </template>
                <template v-else>
                    <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                    text }}</span>
                </template>
                </div>
            </template>
            </a-table>
        </div>

        <!-- 结论 -->
        <div class="sub-content-result" style="margin-top:30px;">
            <p style="width:100%;word-break:break-all;word-wrap:break-word;font-size:18px;font-weight:bold;margin:0;">
            结论: {{ misfire_detection_group_object.test_result || '检测正常' }}
            </p>
        </div>

        <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;display:block;margin-top: 100px;">
            <span class="blue-title-nav-bar"
            style="background:#155cf0;width:200px;height:35px;line-height:35px;color:white;font-weight:bold;display:block;text-align:center;box-sizing:border-box;">
            轮胎检测
            </span>
        </div>

        <!-- 四列检测结果表格 -->
        <div style="margin:20px 0;">
            <a-table class="sub-content-table" :columns="detect_result_columns"
            :data-source="detect_group_object_table_data[tire_wear_group_object.group_object_id]" :pagination="false"
            bordered size="small" style="font-size:12px;">
            <template
                v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
                :slot="col" slot-scope="text">
                <div :key="col" style="padding:8px;text-align:center;">
                <template v-if="col == 'result' || col == 'result_1'">
                    <el-image fit="contain" v-if="text != undefined && text != ''"
                    :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                    style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                    </el-image>
                    <span class="auto-customer-info-table-content"
                    style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
                </template>
                <template v-else>
                    <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                    text }}</span>
                </template>
                </div>
            </template>
            </a-table>
        </div>

        <!-- 结论部分 -->
        <div class="sub-content-result" style="margin-top:30px;margin-bottom:20px;">
            <p style="font-size:16px;font-weight:bold;margin:0;">
            结论: {{ tire_wear_group_object.test_result || '检测正常' }}
            </p>
        </div>

        <!-- 页码 -->
        <div v-if="order.menu_mode == 'COMPREHENSIVE'" class="page-number"
            style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
            {{ total_page - 3 }}/{{ total_page }}
        </div>
        <div v-if="order.menu_mode == 'BASE'" class="page-number"
            style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
            6/{{ total_page }}
        </div>
    </div>
    <!-- 第7页：发动机检测 -->
    <div v-if="order.menu_mode == 'COMPREHENSIVE'" class="page"
      style="width:100%;page-break-after: always; padding: 20px 30px; background: white; height: 297mm; box-sizing: border-box; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;">
        <span class="blue-title-nav-bar"
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; box-sizing: border-box; ">
          发动机检测
        </span>
      </div>

      <!-- 车辆示意图区域 - 强制样式控制 -->
      <div
        style="margin-top:30px !important;text-align:center !important;width:100% !important;height:500px !important;display:flex !important;align-items:center !important;justify-content:center !important;position:relative !important;z-index:10 !important;overflow:hidden !important;">
        <img :src="engine_inspection_group_object.cover_url"
          style="height:250px !important;width:auto !important;max-width:100% !important;object-fit:contain !important;object-position:center !important;display:block !important;margin:0 auto !important;">
      </div>

      <!-- 检测结果表格 -->
      <div style="margin-top:30px;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[engine_inspection_group_object.group_object_id]"
          :pagination="false" bordered size="small" style="width:100%;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col">
              <template v-if="col == 'result' || col == 'result_1'">
                <el-image fit="contain" v-if="text != undefined && text != ''"
                  :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                  style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                </el-image>
                <span class="auto-customer-info-table-content"
                  style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
              </template>
              <template v-else>
                <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                  text }}</span>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论 -->
      <div class="sub-content-result" style="margin-top:30px;">
        <p style="width:100%;word-break:break-all;word-wrap:break-word;font-size:18px;font-weight:bold;margin:0;">
          结论: {{ engine_inspection_group_object.test_result || '检测正常' }}
        </p>
      </div>

      <!-- 页码 -->
      <div class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        {{ total_page - 2 }}/{{ total_page }}
      </div>
    </div>
    <!-- 第8页：变速箱检测 -->
    <div v-if="order.menu_mode == 'COMPREHENSIVE'" class="page"
      style="width:100%;page-break-after: always; padding: 20px 30px; background: white; height: 297mm; box-sizing: border-box; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;">
        <span class="blue-title-nav-bar"
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; box-sizing: border-box; ">
          变速箱检测
        </span>
      </div>

      <!-- 车辆示意图区域 - 强制样式控制 -->
      <div
        style="margin-top:30px !important;text-align:center !important;width:100% !important;height:500px !important;display:flex !important;align-items:center !important;justify-content:center !important;position:relative !important;z-index:10 !important;overflow:hidden !important;">
        <img :src="gearbox_group_object.cover_url"
          style="height:250px !important;width:auto !important;max-width:100% !important;object-fit:contain !important;object-position:center !important;display:block !important;margin:0 auto !important;">
      </div>

      <!-- 检测结果表格 -->
      <div style="margin-top:30px;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[gearbox_group_object.group_object_id]" :pagination="false"
          bordered size="small" style="width:100%;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col">
              <template v-if="col == 'result' || col == 'result_1'">
                <el-image fit="contain" v-if="text != undefined && text != ''"
                  :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                  style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                </el-image>
                <span class="auto-customer-info-table-content"
                  style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
              </template>
              <template v-else>
                <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                  text }}</span>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论 -->
      <div class="sub-content-result" style="margin-top:30px;">
        <p style="width:100%;word-break:break-all;word-wrap:break-word;font-size:18px;font-weight:bold;margin:0;">
          结论: {{ gearbox_group_object.test_result || '检测正常' }}
        </p>
      </div>

      <!-- 页码 -->
      <div class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        {{ total_page - 1 }}/{{ total_page }}
      </div>
    </div>
    <div v-if="order.menu_mode == 'COMPREHENSIVE'" class="page"
      style="width:100%;page-break-after: always; padding: 20px; background: white; height: 297mm; box-sizing: border-box; position: relative;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;">
        <span class="blue-title-nav-bar"
          style="background: #155cf0; width: 200px; height: 40px; line-height: 40px; color: white; font-weight: bold; display: block; text-align: center; box-sizing: border-box; ">
          检测说明
        </span>
      </div>
      <div class="detect-explain-content" style="display: flex; padding: 15px 20px; background: white;margin-top: 40px;">
        <!-- 左侧区域 -->
        <div style="flex: 1; padding-right: 25px;margin-top: 20px;">
          <p style="text-align: justify; line-height: 1.6; font-size: 13px; margin-bottom: 30px;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;退车承诺检测项目为【"结构件检测"，"浸泡检测"，"火烧检测"】，自检测当日（出具本《车辆检测报告》）起100日内如发现上述承诺项目检测有误，经核实，若争议属实，委托人（买方）可根据检测报告中注明的退车保障金全额退车，（如在保障期100天内使用过程中发生事故，则在退车保障金基础上按一定折损后进行回购）逾期未提出的视为放弃权利主张，检测方不再承担保价退车责任。
          </p>
          
          <div style="margin-top: 50px; position: relative;">
            <div style="display: flex; align-items: center;">
              <span style="font-size: 13px;">检测方（签章）：</span>
              <span style="font-size: 13px; margin-left: 20px;">福州车质宝车辆鉴定中心</span>
            </div>
            <div class="detect-explain-searl" style="position: absolute; left: 160px; top: -10px; z-index: 10;">
              <img :src="urls.static.company_searl" style="width: 140px; height: 140px;" />
            </div>
          </div>
          
          <div style="margin-top: 50px;">
            <div style="display: flex; align-items: center;">
              <span style="font-size: 13px;">检测师：</span>
              <div style="margin-left: 100px;">
                <img :src="inspector.sign.image_url" style="height: 120px; width: auto;" v-if="inspector.sign.image_url" />
              </div>
            </div>
          </div>
          
          <div style="margin-top: 15px;">
            <span style="font-size: 13px;">退车保障金（回购金额）: {{ auto.amount_of_protection_number }}</span>
          </div>
          
          <div style="margin-top: 8px;">
            <span style="font-size: 13px;">{{ auto.amount_of_protection_zh }}</span>
          </div>
          
          <div style="margin-top: 15px;">
            <span style="font-size: 13px;">委托人：{{ customer.name }}</span>
          </div>
        </div>
        
        <!-- 右侧区域 -->
        <div class="detect-explain-content-right" style="flex: 0 0 400px; padding-left: 25px;;margin-top: 20px;">
          <div style="text-align: center;">
            <h3 style="color: #155cf0; font-size: 15px; font-weight: bold; margin-bottom: 12px;">鉴定师资格证书</h3>
            <div style="margin-bottom: 12px;">
              <img class="appraisal_certificates_image" v-if="inspector.appraisal_certificates && inspector.appraisal_certificates[0].image_url" 
                   :src="inspector.appraisal_certificates[0].image_url" 
                   style="width: 400px; height: auto; border-radius: 4px; border: 1px solid #ddd;" />
            </div>
          </div>
          
          <div style="margin-top: 15px;">
            <table style="width: 100%; border-collapse: collapse;">
              <tr>
                <td style="padding: 6px 0; font-size: 13px;">检测师</td>
                <td style="padding: 6px 0; text-align: center; font-size: 13px;">:</td>
                <td style="padding: 6px 0; font-size: 13px;">{{ inspector.name }}</td>
              </tr>
              <tr>
                <td style="padding: 6px 0; font-size: 13px;">检测时间</td>
                <td style="padding: 6px 0; text-align: center; font-size: 13px;">:</td>
                <td style="padding: 6px 0; font-size: 13px;">{{ order.create_at | formatDate }}</td>
              </tr>
              <tr>
                <td style="padding: 6px 0; font-size: 13px;">退车保障金</td>
                <td style="padding: 6px 0; text-align: center; font-size: 13px;">:</td>
                <td style="padding: 6px 0; font-size: 13px;">{{ auto.amount_of_protection_number }}</td>
              </tr>
              <tr>
                <td style="padding: 6px 0; font-size: 13px;"></td>
                <td style="padding: 6px 0; text-align: center; font-size: 13px;"></td>
                <td style="padding: 6px 0; font-size: 13px;">{{ auto.amount_of_protection_zh }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!-- 页码 -->
      <div class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        {{ total_page }}/{{ total_page }}
      </div>
    </div>
    <div v-if="order.menu_mode == 'BASE'" class="page"
      style="width:100%;padding:20px;box-sizing:border-box; position: relative; page-break-after: always;">
      <!-- 蓝色标题栏 -->
      <div class="blue-title-nav-bar-container" style="background: #eef4fe; width: 100%; height: 40px;display:block;">
        <span class="blue-title-nav-bar"
          style="background:#155cf0;width:200px;height:35px;line-height:35px;color:white;font-weight:bold;display:block;text-align:center;box-sizing:border-box;">
          火烧检测
        </span>
      </div>
      <!-- 车辆火烧检测示意图 - 强制样式控制 -->
      <div
        style="margin:30px 0 !important;text-align:center !important;width:100% !important;height:250px !important;display:flex !important;align-items:center !important;justify-content:center !important;position:relative !important;z-index:10 !important;overflow:hidden !important;">
        <img :src="misfire_detection_group_object.cover_url"
          style="height:250px !important;width:auto !important;max-width:100% !important;object-fit:contain !important;object-position:center !important;display:block !important;margin:0 auto !important;">
      </div>

      <!-- 四列检测结果表格 -->
      <div style="margin:20px 0;">
        <a-table class="sub-content-table" :columns="detect_result_columns"
          :data-source="detect_group_object_table_data[misfire_detection_group_object.group_object_id]"
          :pagination="false" bordered size="small" style="font-size:12px;">
          <template
            v-for="col in ['detect_item', 'result', 'warning_count', 'detect_item_1', 'result_1', 'warning_count_1']"
            :slot="col" slot-scope="text">
            <div :key="col" style="padding:8px;text-align:center;">
              <template v-if="col == 'result' || col == 'result_1'">
                <el-image fit="contain" v-if="text != undefined && text != ''"
                  :src="(text == '正常') ? require('@/assets/ok.png') : require('@/assets/warning.png')"
                  style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;">
                </el-image>
                <span class="auto-customer-info-table-content"
                  style="vertical-align: middle; font-size: 14px;text-align: left;">{{ text }}</span>
              </template>
              <template v-else>
                <span class="auto-customer-info-table-content" style="font-size: 14px; color: #333;text-align: left;">{{
                  text }}</span>
              </template>
            </div>
          </template>
        </a-table>
      </div>

      <!-- 结论部分 -->
      <div class="sub-content-result" style="margin-top:30px;margin-bottom:20px;">
        <p style="font-size:16px;font-weight:bold;margin:0;">
          结论: {{ misfire_detection_group_object.test_result || '检测正常' }}
        </p>
      </div>

      <!-- 检测说明部分 -->
      <div class="detect-explain" style="margin-top:20px;">
        <h4 style="font-size:14px;font-weight:bold;margin-bottom:10px;">检测说明</h4>
        <div style="font-size:12px;line-height:1.6;color:#333;">
          <p style="margin:5px 0;">1. 本报告中的所有检测项目均依据相关标准，仅对车辆当前状态，不对车辆历史状况做出判断。</p>
          <p style="margin:5px 0;">2. 本检测报告中的"检测结果"仅反映检测人员根据检测标准对车辆当前状态的判断，仅供参考。</p>
          <p style="margin:5px 0;">3. 检测结果分为三个等级：</p>
          <p style="margin:5px 0;padding-left:20px;">(1)正常车：结构件有序，则判定为正常车；重要件有序，加强件有序，不予定为事故车。</p>
          <p style="margin:5px 0;padding-left:20px;">
            (2)泡水车：车辆有身体受损在1/3以上(含座椅以上)，各种电设备，电子元件(包括线束)有锈蚀或更换，即作有序，主体有序的，同时发动机、变速箱等重要部件有锈蚀或更换的。</p>
          <p style="margin:5px 0;padding-left:20px;">(3)火烧车：车辆发生火灾损坏超过0.5平方米，经修复仍存在安全隐患的车辆。</p>
          <p style="margin:5px 0;">4. 为了保障您的合法权益，请在购买车辆前委托第三方检测机构对车辆进行全面检测，承担检测费用的公司对检测的准确性负责，承担检测结果的法律责任。</p>
          <p style="margin:5px 0;">5. 官方客服热线：15606911446,13788891512,18695600029</p>
        </div>
      </div>

      <!-- 页码 -->
      <div class="page-number"
        style="position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); font-size: 14px; color: #666;">
        6/{{ total_page }}
      </div>
    </div>

    <div v-if="!order.detected && !loading">
      <p style="width:100%;margin-top:100px;height:100px;text-align:center;">
        {{ error_tip }}
      </p>
    </div>
  </div>

</template>

<script>

import request from '../../api/request'
import urls from '../../api/urls'
import moment from 'moment'
import menu_model from '../../model/menu'
import global_define from '../../library/global/define'
import company_model from '../../model/company'
import { customer_columns, base_info_columns, detect_result_columns } from '../../model/columns'
import { auto_model, customer_model, inspector_model, order_model_data, order_info_model } from '../../model/report_data_template'

export default {
  name: 'ReportReport',
  head: {
    title: "检测报告单",
    meta: [
      { name: 'description', content: '检测报告单' }
    ]
  },
  data: function () {

    return {
      urls: urls,
      moreText: "更多+",
      visible: false,
      order_id: "",
      order: order_model_data,
      menu: menu_model,
      customer: customer_model,
      order_info: order_info_model,
      inspector: inspector_model,
      auto: auto_model,
      group_object_result: {

      },
      data_dict: {

      },
      image_map: {

      },
      image_size: 100,
      previewVisible: false,
      previewImage: "",
      detect_result_table_data: [],
      detect_result_columns: detect_result_columns,
      customer_columns: customer_columns,
      customer_table_data: [],
      base_info_columns: base_info_columns,
      base_info_table_data: [],
      global_define: global_define,
      default_cover_url: '',

      detect_group_object_table_data: {
      },

      lacquered_group_object: {},             //  漆面检测
      gearbox_group_object: {},           //  变速箱检测
      reinforcement_group_object: {},         // 加强件检测
      structure_group_object: {},         // 结构件检测
      misfire_detection_group_object: {},     //  失火检测
      illumination_inspection_group_object: {},   // 灯光组检测
      tire_wear_group_object: {},     // 轮胎检测
      soaking_investigation_group_object: {}, // 泡水排查
      engine_inspection_group_object: {}, // 	发动机检测
      car_window_glass_group_object: {}, // 	车窗玻璃
      company: company_model,
      loading: false,
      print_show: true,
      page_show: false,
      error_tip: "订单不存在",
      total_page: 6,
      auto_address: "",
    }
  },
  methods: {
    async print() {
      this.print_show = false
      await this.$forceUpdate()
      window.print()
    },
    getDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + " 年 " + month + " 月 " + strDate + " 日 ";
      return currentdate;
    },
    fetch_company() {
      let company_info_resp = request.company.company()
      company_info_resp.then((response) => {
        if (response.status == 200 && response.data.code == 0) {
          if (response.data.data) {
            this.company = response.data.data
          }
        }
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(event) {
      this.previewImage = event.target.currentSrc;
      this.previewVisible = true;
    },
    load() {

      window.onbeforeprint = function () {
        // try {
        //     watermark.remove()
        // }
        // catch (err) {
        //     console.log()
        // }

        //将一些不需要打印的隐藏
      }
      window.onafterprint = function () {
        // if (this.$route.query.watermark != 0) {
        //     watermark.load()
        // }

        this.print_show = true
        //放开隐藏的元素

      }
      // this.fetch_company()
      var width = screen.width - 20 - 10 * 2 - 1.25 * 16 * 2 - 2 * 10 - 2 * 5
      this.image_size = width / 3.0
      this.order_id = this.$route.query.order_id
      this.fetch_company()
      this.fetchOrder()
      this.fetchReportOrder()
      console.log("reloadData")
      this.reloadData()
    },
    reloadData() {
      this.generateCustomerTableData()
      this.generateBaseInfoTableData()
      this.generateDetectTableData()
      this.generateDetectResultTableData()

      if (this.$route.query.print == 1) {
        document.title = this.order_id + ".pdf"
        setTimeout(() => {
          this.print();
          setTimeout(() => {
            window.close();
          }, 5);
        }, 5);
      }
    },
    fetchOrder() {
      this.loading = true
      var order_detial_resp = request.order.detail(this.order_id, false)
      order_detial_resp.then((response) => {
        this.loading = false
        var failed_message = "获取订单信息失败"
        if (response && response.status == 200 && response.data.code == 0) {
          if (response.data.data) {
            this.order = response.data.data
            if (this.order.menu_mode == 'BASE') {
              this.total_page = 6
            }
            else {
              this.total_page = 10
            }
            this.fetchAuto()
            this.fetchCustomer()
            this.fetchInspector()
            if (this.order.detected == true) {
              this.error_tip = JSON.stringify(this.order)
            }
            else {
              this.error_tip = "订单未检测完成"
            }
          }
          this.reloadData()
        }
        else {
          if (response.data && response.data.message) {
            failed_message = response.data.message
          }
          this.$message.error(failed_message)
        }
      })
        .catch((error) => {
          this.loading = false
          if (error) {
            this.$error({
              title: "请求失败，请联系管理员",
              content: String(error),
            });
          }
        })
    },
    fetchReportOrder() {
      this.loading = true
      var order_detial_resp = request.order.report_order_detail(this.order_id, false)
      order_detial_resp.then((response) => {
        this.loading = false
        var failed_message = "获取订单信息失败"
        if (response && response.status == 200 && response.data.code == 0) {
          if (response.data.data) {
            this.order_info = response.data.data
            if (this.order_info && this.order_info.covers && this.order_info.covers.length > 0) {
              this.default_cover_url = this.order_info.covers[0]
            }
            if (this.order_info.export_groups.length > 0) {
              this.error_tip = JSON.stringify(this.order_info)
            }
            else {
              this.error_tip = "订单未检测完成"
            }
          }
          this.reloadData()
        }
        else {
          if (response.data && response.data.message) {
            failed_message = response.data.message
          }
          this.$message.error(failed_message)
        }
      })
        .catch((error) => {
          this.loading = false
          if (error) {
            this.$error({
              title: "请求失败，请联系管理员",
              content: String(error),
            });
          }
        })
    },
    fetchAuto() {
      this.loading = true
      var detial_resp = request.order.auto_detail(this.order.auto_id, false)
      detial_resp.then((response) => {
        this.loading = false
        var failed_message = "获取订单信息失败"
        if (response && response.status == 200 && response.data.code == 0) {
          if (response.data.data) {
            this.auto = response.data.data
            this.auto_address = this.auto.register_region.address
            if (this.order_info.export_groups.length > 0) {
              this.error_tip = JSON.stringify(this.order)
            }
            else {
              this.error_tip = "订单未检测完成"
            }
            this.reloadData()
          }
        }
        else {
          if (response.data && response.data.message) {
            failed_message = response.data.message
          }
          this.$message.error(failed_message)
        }
      })
        .catch((error) => {
          this.loading = false
          if (error) {
            this.$error({
              title: "请求失败，请联系管理员",
              content: String(error),
            });
          }
        })
    },
    fetchCustomer() {
      this.loading = true
      var detial_resp = request.order.customer_detail(this.order.customer_id, false)
      detial_resp.then((response) => {
        this.loading = false
        var failed_message = "获取订单信息失败"
        if (response && response.status == 200 && response.data.code == 0) {
          if (response.data.data) {
            this.customer = response.data.data
            if (this.order_info.export_groups.length > 0) {
              this.error_tip = JSON.stringify(this.order)
            }
            else {
              this.error_tip = "订单未检测完成"
            }
            this.reloadData()
          }
        }
        else {
          if (response.data && response.data.message) {
            failed_message = response.data.message
          }
          this.$message.error(failed_message)
        }
      })
        .catch((error) => {
          this.loading = false
          if (error) {
            this.$error({
              title: "请求失败，请联系管理员",
              content: String(error),
            });
          }
        })
    },
    fetchInspector() {
      this.loading = true
      var detial_resp = request.order.inspector_detail(this.order.inspector_id, false)
      detial_resp.then((response) => {
        this.loading = false
        var failed_message = "获取订单信息失败"
        if (response && response.status == 200 && response.data.code == 0) {
          if (response.data.data) {
            this.inspector = response.data.data
            if (this.order_info.export_groups.length > 0) {
              this.error_tip = JSON.stringify(this.order)
            }
            else {
              this.error_tip = "订单未检测完成"
            }
            this.reloadData()
          }
        }
        else {
          if (response.data && response.data.message) {
            failed_message = response.data.message
          }
          this.$message.error(failed_message)
        }
      })
        .catch((error) => {
          this.loading = false
          if (error) {
            this.$error({
              title: "请求失败，请联系管理员",
              content: String(error),
            });
          }
        })
    },
    generateGroupObjectResult() {
      if (this.order_info.export_groups) {
        for (var group_object of this.order_info.export_groups) {
          var warning_count = 0
          var success_count = 0
          if (group_object.group && group_object.group.group_items) {
            for (var group_item of group_object.group.group_items) {
              var warning_list = []
              var empty = true
              var check_dict = {}
              if (group_item.items) {
                for (var item of group_item.items) {
                  if (group_object.detect_detectitemobject_group_object) {
                    var image_dict = {}
                    for (var item_object of group_object.detect_detectitemobject_group_object) {
                      var detect_group_item = item_object.detect_group_item
                      var detect_item = item_object.detect_item
                      if (group_item.identifier == detect_group_item.identifier && item.identifier == detect_item.identifier) {
                        if (item.mode == 'BOOLEAN' && !item.tagged) {
                          if (item_object.checked == true) {
                            empty = false
                          }
                          if (item.finish_mode == "Success") {
                            if (item_object.checked == true) {
                              success_count++
                              item.tagged = true
                            }
                          }
                          else if (item.finish_mode == "Warning") {
                            if (item_object.checked == true) {
                              warning_count++
                              item.tagged = true
                              if (warning_list.includes(item.name) == false) {
                                warning_list.push(item.name)
                              }
                            }
                          }
                        }
                        else if (item.mode == "IMAGES") {
                          image_dict[item.identifier] = item_object.images
                        }
                      }
                    }
                    this.image_map[group_item.identifier] = image_dict
                  }
                }
              }
              check_dict['empty'] = empty
              check_dict['warning_list'] = warning_list
              this.data_dict[group_item.identifier] = check_dict
            }
          }

          group_object["success_count"] = success_count
          group_object["warning_count"] = warning_count

          if (group_object.group.identifier) {
            this.group_object_result[group_object.group.identifier] = group_object
          }
        }
      }
      this.$forceUpdate()
    },
    generateDetectResultTableData() {
      var data = []
      if (this.order_info.export_groups) {
        var split_count = parseInt(this.order_info.export_groups.length / 2)
        if (this.order_info.export_groups.length % 2 > 0) {
          split_count++
        }
        for (var index = 0; index < split_count; index++) {
          var group_object = this.order_info.export_groups[index * 2]
          if (group_object) {
            var result_message = "正常"
            var detect_item = ""
            detect_item = group_object.group_name
            var warning_count = String(group_object['warning_count'])
            if (warning_count && parseInt(warning_count) > 0) {
              result_message = "有" + warning_count.toString() + "处瑕疵"
            }
            var result_message_1 = ""
            var warning_count_1 = ""
            var detect_item_1 = ""
            if (2 * index + 1 < this.order_info.export_groups.length) {
              var next_group_object = this.order_info.export_groups[2 * index + 1]
              detect_item_1 = next_group_object.group_name
              result_message_1 = "正常"
              warning_count_1 = String(next_group_object['warning_count'])
              if (warning_count_1 && parseInt(warning_count_1) > 0) {
                result_message_1 = "有" + warning_count_1.toString() + "处瑕疵"
              }
            }
            var data_dict = {
              key: group_object.group_object_id,
              detect_item: detect_item,
              result: result_message,
              warning_count: warning_count,
              detect_item_1: detect_item_1,
              result_1: result_message_1,
              warning_count_1: warning_count_1,
            }
            data.push(data_dict)
          }
        }
      }
      this.detect_result_table_data = data;
    },
    generateCustomerTableData() {
      var data = []
      var data_dict = {
        name_item: "姓名：",
        name: this.customer.name,
        mobile_item: "电话：",
        mobile: this.customer.mobile,
        id_item: "身份证：",
        id: this.customer.idcard_no,
      }
      data.push(data_dict)
      this.customer_table_data = data;
    },
    generateBaseInfoTableData() {
      var data = []
      var data_dict = {
        info_item: "注册地：",
        info: String(this.auto_address),
        info_item_1: "初登日期：",
        info_1: this.auto.first_boarding_date ? moment(String(this.auto.first_boarding_date)).format('YYYY年MM月DD日') : "未填写",
        info_item_2: "表显里程：",
        info_2: String(this.auto.meter_mileage),
      }
      data.push(data_dict)
      data_dict = {
        info_item: "国/进/合：",
        info: this.menu.vehicle_source[this.auto.vehicle_source],
        info_item_1: "排量：",
        info_1: this.auto.displacement + " " + this.auto.displacement_unit,
        info_item_2: "变速箱：",
        info_2: this.auto.gearbox_type[this.auto.gearbox_type],
      }
      data.push(data_dict)
      data_dict = {
        info_item: "车身颜色：",
        info: this.auto.vehicle_color,
        info_item_1: "车辆用途：",
        info_1: this.auto.vehicle_use[this.auto.vehicle_use],
        info_item_2: "使用性质：",
        info_2: this.auto.nature_of_use[this.auto.nature_of_use],
      }
      data.push(data_dict)
      data_dict = {
        info_item: "保养情况：",
        info: this.auto.engine_no,
        info_item_1: "年检有效期：",
        info_1: this.auto.annual_inspection_expiration ? moment(String(this.auto.annual_inspection_expiration)).format('YYYY年MM月DD日') : "未填写",
      }
      data.push(data_dict)
      this.base_info_table_data = data;
    },
    generateDetectTableData() {
      // lacquered_group_object: {},             //  漆面检测
      // gearbox_group_object: {},           //  变速箱检测
      // reinforcement_group_object: {},         // 加强件检测
      // structure_group_object: {},         // 结构件检测
      // misfire_detection_group_object: {},     //  失火检测
      // illumination_inspection_group_object: {},   // 灯光组检测
      // tire_wear_group_object: {},     // 轮胎检测
      // soaking_investigation_group_object: {}, // 泡水排查
      // engine_inspection_group_object: {}, // 	发动机检测
      // car_window_glass_group_object: {}, // 	车窗玻璃
      for (var group_object of this.order_info.export_groups) {
        if (group_object.group_name == '漆面检测') {
          this.lacquered_group_object = group_object
        }
        else if (group_object.group_name == '变速箱检测') {
          this.gearbox_group_object = group_object
        }
        else if (group_object.group_name == '加强件检测') {
          this.reinforcement_group_object = group_object
        }
        else if (group_object.group_name == '结构件检测') {
          this.structure_group_object = group_object
        }
        else if (group_object.group_name == '火烧检测') {
          this.misfire_detection_group_object = group_object
        }
        else if (group_object.group_name == '灯光检测') {
          this.illumination_inspection_group_object = group_object
        }
        else if (group_object.group_name == '轮胎检测') {
          this.tire_wear_group_object = group_object
        }
        else if (group_object.group_name == '泡水检测') {
          this.soaking_investigation_group_object = group_object
        }
        else if (group_object.group_name == '发动机检测') {
          this.engine_inspection_group_object = group_object
        }
        else if (group_object.group_name == '车窗玻璃') {
          this.car_window_glass_group_object = group_object
        }
        var data = []

        var group_items = []
        for (var gi of group_object.items) {
          if (gi.choice_mode == "SINGLE" || gi.choice_mode == "MULTIPLE") {
            group_items.push(gi)
          }
        }
        var split_index = parseInt(group_items.length / 2)
        if (group_items.length % 2 > 0) {
          split_index = split_index + 1
        }
        for (var index = 0; index < split_index; index++) {

          var group_item = group_items[2 * index]
          var data_dict = {
            key: group_object.group_object_id + "_" + group_item.identifier + "_" + String(index)
          }
          var result_message = "正常"
          var detect_item = group_item.group_item_name
          var warning_count = group_item.warning_count


          if (warning_count > 0) {
            result_message = "有" + warning_count.toString() + "处瑕疵"
          }

          data_dict['detect_item'] = detect_item
          data_dict['result'] = result_message
          data_dict['warning_count'] = warning_count

          if (2 * index + 1 < group_items.length) {
            var group_item_1 = group_items[2 * index + 1]
            var result_message_1 = "正常"
            var detect_item_1 = group_item_1.group_item_name
            var warning_count_1 = group_item_1.warning_count

            if (warning_count_1 > 0) {
              result_message_1 = "有" + warning_count_1.toString() + "处瑕疵"
            }

            data_dict['detect_item_1'] = detect_item_1
            data_dict['result_1'] = result_message_1
            data_dict['warning_count_1'] = warning_count_1
          }

          data.push(data_dict)
        }
        this.detect_group_object_table_data[group_object.group_object_id] = data
      }
    },
    clickMore() {
      this.visible = !this.visible
      if (this.visible == true) {
        this.moreText = "收起-"
      }
      else {
        this.moreText = "更多+"
      }
    },
  },
  created() {
    this.load()
  },
  components: {

  }
}
</script>

<style>
.auto-info-summary-table .ant-table-thead>tr>th,
.auto-info-summary-table .a-table thead tr th {
  text-align: left !important;
}

@media print {

  /* 强制重置所有元素 */
  *,
  *::before,
  *::after {
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    outline: 0 !important;
  }

  html {
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  body {
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 彻底移除页面边距 */
  @page {
    size: A4;
    margin: 0mm !important;
    padding: 0mm !important;
    border: none !important;
  }

  /* 使用viewport单位确保完全覆盖 */
  .page {
    width: 100vw !important;
    height: 100vh !important;
    min-width: 100vw !important;
    min-height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    outline: none !important;
    box-sizing: border-box !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    /* 移除page-break-before: avoid，避免在build环境下产生空白页 */
    z-index: 9999 !important;
  }

  .page:last-child,
  .page:nth-child(3),
  .page:nth-child(5) {
    page-break-after: avoid !important;
  }

  /* 表格样式优化 - 适当减小字体 */
  .ant-table,
  .a-table {
    font-size: 32px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 确保根容器也铺满 */
  .report-container {
    width: 100vw !important;
    height: 100vh !important;
    top: 0 !important;
    left: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 封面页内容 */
  .page:first-child .print-cover-page {
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 2cm !important;
    box-sizing: border-box !important;
    position: relative !important;
  }

  /* 内容页样式 */
  .page:not(:first-child) {
    padding: 1.5cm !important;
    box-sizing: border-box !important;
  }

  /* 检测概要和检测内容区域 */
  .page:not(:first-child) .detect-section {
    padding: 0 30px 25px !important;
    margin: 0 !important;
  }

  /* 第三页到第七页的检测页面特殊样式 */
  .page:nth-child(n+3) {
    display: flex !important;
    flex-direction: column !important;
  }

  /* 检测页面的图片区域 */
  .page:nth-child(n+3) .detect-image-section {
    flex: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 25px 30px !important;
  }

  /* 检测页面的表格区域 */
  .page:nth-child(n+3) .detect-table-section {
    padding: 0 30px 30px !important;
  }

  .page:not(:first-child)>div:first-child div {
    font-size: 22px !important;
  }

  /* 检测结果文字 */
  .page:not(:first-child) .ant-table-tbody span {
    font-size: 18px !important;
  }

  /* 客户信息表格内容字体大小 - 覆盖上面的通用规则 */
  .page:not(:first-child) .ant-table-tbody .auto-customer-info-table-content,
  .page:not(:first-child) .a-table tbody .auto-customer-info-table-content,
  .page:not(:first-child) div.auto-customer-info-table-content,
  .page:not(:first-child) span.auto-customer-info-table-content {
    font-size: 24px !important;
    font-weight: normal !important;
  }

  /* 检测机构信息文字 */
  .page:not(:first-child) .detect-info {
    font-size: 18px !important;
  }

  /* 检测结果及保养建议文字 */
  .page:not(:first-child) .maintenance-text {
    font-size: 18px !important;
  }

  /* 印章文字 */
  .page:not(:first-child) .stamp-text {
    font-size: 16px !important;
  }

  /* 专门为蓝色标题栏恢复15px左边距 */
  .page span[style*="background:#155cf0"],
  .page span[style*="background: #155cf0"] {
    padding-left: 15px !important;
  }

  .blue-title-nav-bar {
    width: 280px !important;
    height: 80px !important;
    line-height: 80px !important;
    font-size: 24px !important;
    text-align: center;
    font-weight: bold;
  }

  /* 隐藏不必要的元素 */
  .a-spin,
  .print_div,
  #wm_div_id,
  #mask_div_id {
    display: none !important;
  }

  .blue_right_words {
    margin-left: 10px !important;
    font-size: 28px !important;
    height: 45px !important;
    line-height: 45px !important;
  }

  .blue_flag {
    height: 45px !important;
  }

  .auto_customer_table {
    margin-top: 30px !important;
    font-size: 28px !important;
  }

  /* 确保颜色正确打印 */
  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* 第二页专用样式 - 按用户要求修改 */
  /* 蓝色标题栏高度减小 */
  .blue-title-bar {
    height: 280px !important;
    padding: 0 60px !important;
  }

  .auto-detect-report-title-part {
    margin-left: 25px !important;
  }

  .auto-detect-report {
    font-size: 30px !important;
    margin-left: 0.8cm !important;
  }

  .auto-detect-report-eng {
    font-size: 30px !important;
    margin-left: 0.8cm !important;
  }

  .auto-detect-report-logo {
    width: 110px !important;
    height: 110px !important;
  }

  /* 第二页logo样式 */
  .page:nth-child(2) .blue-title-bar .auto-detect-report-logo {
    width: 110px !important;
    height: 110px !important;
  }

  .page:nth-child(2) .blue-title-bar .logo-title-part>div:first-child {
    width: 110px !important;
    height: 110px !important;
    margin: 1cm 30px 1cm 0 !important;
  }

  .auto-info-zone {
    margin-top: 40px !important;
    font-size: 28px !important;
  }

  .auto-info-base-title {
    font-size: 28px !important;
  }

  .auto-info-base-sub {
    margin-top: 18px !important;
    font-size: 28px !important;
  }

  .auto-info-base-qrcode-text {
    font-size: 28px !important;
  }

  .auto-info-summary {
    margin-top: 40px !important;
  }

  .auto-info-summary-title {
    font-size: 28px !important;
  }

  /* 特定表格内容字体大小 - 覆盖上面的通用规则 */
  .page:not(:first-child) .auto-info-summary-table .auto-info-summary-result {
    font-size: 22px !important;
    font-weight: normal !important;
    text-align: left !important;
    margin-left: 10px !important;
  }

  .auto-info-summary-table {
    margin-top: 20px !important;
    text-align: left !important;
  }

  .auto-info-summary-table .ant-table-thead>tr>th,
  .auto-info-summary-table .a-table thead tr th {
    font-size: 22px !important;
    font-weight: bold !important;
    line-height: 1.3 !important;
    padding: 14px !important;
  }

  .auto-info-inspector {
    margin-top: 40px !important;
  }

  .auto-info-inspector-title {
    font-size: 28px !important;
  }

  .auto-info-inspector-info {
    margin-top: 20px !important;
  }

  .auto-info-inspector-info span {
    font-size: 22px !important;
    width: 200px !important;
    margin-top: 8px !important;
  }

  .auto-info-result {
    margin-top: 20px !important;
  }

  .auto-info-result>p {
    font-size: 28px !important;
  }

  .auto-info-img {
    height: 300px !important;
  }

  .auto-info-img img {
    width: 380px !important;
    height: 300px !important;
  }


  .sub-content-table .ant-table-thead>tr>th,
  .sub-content-table .a-table thead tr th {
    font-size: 28px !important;
    font-weight: normal !important;
    line-height: 1.3 !important;
    padding: 14px !important;
  }

  .sub-content-result {
    font-size: 28px !important;
    font-weight: bold !important;
  }

  .sub-content-result p {
    font-size: 28px !important;
    font-weight: bold !important;
  }

  .auto-customer-info-table-content,
  .auto-base-info-table-content {
    font-size: 24px !important;
    text-align: left !important;
  }


  .auto-base-info-content,
  .sub-content-table,
  .sub-content-result {
    margin-top: 30px !important;
  }

  .detect-explain {
    margin-top: 80px !important;
  }

  .detect-explain h4 {
    font-size: 28px !important;
  }

  .detect-explain div {
    margin-top: 40px !important;
  }

  .detect-explain div p {
    font-size: 26px !important;
  }

  .blue-title-nav-bar-container {
    height: 80px !important;
    margin-top: 40px !important;
    padding: 0 !important;
  }

  .lacquered-title-nav-bar {
    width: 400px !important;
  }

  /* 页码样式 */
  .page-number {
    position: absolute !important;
    bottom: 35px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    font-size: 24px !important;
    color: #333 !important;
    font-weight: normal !important;
  }

  .auto-customer-info-table-content {
    font-size: 24px !important;
  }

  .ant-table-column-title {
    font-size: 28px !important;
    font-weight: bolder !important;
  }

  /* 检测说明页面（COMPREHENSIVE模式）打印样式适配 */
  .page div[style*="padding: 15px 20px"] {
    padding: 12px 16px !important;
  }

  .page div[style*="padding: 15px 20px"] p[style*="font-size: 13px"] {
    font-size: 26px !important;
    line-height: 1.8 !important;
    margin-bottom: 28px !important;
  }

  .page div[style*="padding: 15px 20px"] span[style*="font-size: 13px"] {
    font-size: 26px !important;
  }

  .page h3[style*="font-size: 15px"] {
    font-size: 26px !important;
    margin-bottom: 12px !important;
  }

  .page img[style*="width: 300px"] {
    width: 260px !important;
  }

  .page img[style*="width: 100px; height: 100px"] {
    width: 90px !important;
    height: 90px !important;
  }

  .page img[style*="height: 45px"] {
    height: 40px !important;
  }


  .page div[style*="margin-top: 50px"] {
    margin-top: 40px !important;
  }

  .page div[style*="margin-top: 15px"] {
    margin-top: 15px !important;
  }

  .page div[style*="margin-top: 8px"] {
    margin-top: 8px !important;
  }

  .page div[style*="margin-bottom: 12px"] {
    margin-bottom: 30px !important;
  }

  .appraisal_certificates_image {
    width: 400px !important;
    height: auto !important;
  }

  /* 在检测说明页面的左右两个部分之间添加间隙 */
  .page div[style*="flex: 1; padding-right: 25px"] {
    margin-right: 40px !important;
  }

  .detect-explain-content-right {
    margin-left: 40px !important;
  }

  .detect-explain-content {
    margin-top: 80px !important;
  }

  .detect-explain-content-right div table tr td {
    padding-left: 6px !important;
    padding-right: 1px !important;
    width: auto !important;
    font-size: 18px !important;
    font-size: 28px !important;
  }

  .detect-explain-searl {
    left: 240px !important;
    top: -50px !important;
  }

}
</style>

<style media="screen">
.print_div {
  display: block !important;
}
</style>
